module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/txt-closed@2x-8400f55423363a55c3ec238ff5861d29.png";